export enum SearchResultsSortKey {
  RelevanceAsc = 'relevance-asc',
  PriceDesc = 'price-desc',
  PriceAsc = 'price-asc',
  HoursAsc = 'hours-asc',
  YearAsc = 'year-asc',
  YearDesc = 'year-desc',
  Latest = 'latest',
}
